import {useRedPill} from "Hooks/api/useRedPill";
import {useEffect} from "react";
import {updateAvailableClaims, updateAvailableClaimsStatus, updatePlayerClaims, updatePlayerClaimsStatus} from "Redux/actions/claims";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useMyAccount} from "Hooks/api/useAccount";

function useListClaims() {
    const dispatch = useDispatch();
    const listClaimsPath = "authorizedPaths.claims.list";
    const {execute, status, value, error} = useRedPill(listClaimsPath);

    useEffect(() => {
        if (status !== "idle") {
            dispatch(updatePlayerClaimsStatus(status));
        }
    }, [status]);

    const listPlayerClaims = async () => {
        const res = await execute();

        try {
            if (res.code === 200) {
                dispatch(updatePlayerClaims(res.data));
            }
        } catch (e) {
            //sendExceptionToSentry(e);
            console.log(e);
        }

        return res;
    };

    return {listPlayerClaimsStatus: status, listPlayerClaims};
}

function useAvailableClaims() {
    const dispatch = useDispatch();
    const {execute, status, value, error} = useRedPill("authorizedPaths.claims.available");

    useEffect(() => {
        if (status !== "idle") {
            dispatch(updateAvailableClaimsStatus(status))
        }
    }, [status]);

    const getAvailablePlayerClaims = async () => {
        const res = await execute();

        try {
            if (res.code === 200) {
                if (res?.data?.items) {
                    dispatch(updateAvailableClaims(res.data.items));
                    return res.data.items;
                }
            }
        } catch (e) {
            //sendExceptionToSentry(e);
            console.log(e);
        }

        return false;
    };

    return {getAvailablePlayerClaimsStatus: status, getAvailablePlayerClaims};
}

function useMakeClaim() {
    const {_getMyAccount} = useMyAccount();
    const {singleAccountUpdate} = _getMyAccount();
    const {execute, status, value, error} = useRedPill("authorizedPaths.claims.make");

    const makePlayerClaim = async (claimId, value) => {
        let valueToSend;

        switch (typeof (value)) {
            case "boolean":
                valueToSend = value.toString();
                break;
            default:
                valueToSend = value;
                break;
        }

        const res = await execute({method: "POST", data: {type: claimId, value: valueToSend}});
        await singleAccountUpdate();
        return res;
    }

    return {makePlayerClaimStatus: status, makePlayerClaim};
}

function useUpdateClaim() {
    const {_getMyAccount} = useMyAccount();
    const {singleAccountUpdate} = _getMyAccount();
    const {execute, status, value, error} = useRedPill("authorizedPaths.claims.update");

    const updatePlayerClaim = async (claimId, value) => {
        let valueToSend;

        switch (typeof (value)) {
            case "boolean":
                valueToSend = value.toString();
                break;
            default:
                valueToSend = value;
                break;
        }

        const res = await execute({method: "POST", data: {claimId, value: valueToSend}});
        await singleAccountUpdate();
        return res;
    }

    return {makePlayerClaimStatus: status, updatePlayerClaim};
}

function useSetClaimValue() {
    const {getAvailablePlayerClaims} = useAvailableClaims();

    const setClaimValue = async () => {
        const availableClaims = await getAvailablePlayerClaims();
    }

    return {setClaimValue};
}

// const getUserClaimValue = (claims = []) => {
//     const values = useSelector(state => {
//         const playerClaims = state.claims.playerClaims;
//
//         if (!claims.length) return false;
//
//         let values = {};
//
//         claims.forEach(c => {
//             if(playerClaims.isLoaded && playerClaims.claims.length) {
//                 const match = Object.values(playerClaims.claims)
//                     .sort(function (a, b) {
//                         return new Date(b.createdAt) - new Date(a.createdAt);
//                     }).find(claim => {
//                         return claim.type.toLowerCase() === c.toLowerCase()
//                     });
//
//                 if (match) {
//                     let value = match.value;
//                     if (match.valueType === "Bool") {
//                         value = JSON.parse(match.value);
//                     }
//
//                     values[c] = value;
//                     return;
//                 }
//             }
//
//             values[c] = null;
//         });
//
//         return values;
//     });
//
//     return values;
// };

export const useClaims = () => {
    const {availableClaims, playerClaims, availableClaimsLoaded, playerClaimsLoaded} = useSelector(state => ({
        availableClaims: state.claims.availableClaims.claims,
        availableClaimsLoaded: state.claims.availableClaims.isLoaded,
        playerClaims: state.claims.playerClaims.claims,
        playerClaimsLoaded: state.claims.playerClaims.isLoaded,
    }), shallowEqual);

    return {
        availableClaims,
        playerClaims,
        availableClaimsLoaded,
        playerClaimsLoaded,
        // getUserClaimValue,
        _set: useSetClaimValue,
        _list: useListClaims,
        _available: useAvailableClaims,
        _make: useMakeClaim,
        _update: useUpdateClaim,
    };
};
